import { withWindow } from './withWindow';

/**
 * Signal channel for "this iframe is the Templates-gallery preview modal."
 *
 * Set as a URL query param at iframe construction time so the guest site can
 * detect it synchronously on first render (no postMessage flash). Specific to
 * the WebsiteDesignerV2 TemplatePreviewDialog — other previews (live editor,
 * standalone tabs, split view) intentionally do NOT set this and continue to
 * render full-bleed (`100svh`) headers.
 *
 * The flag exists because TemplatePreviewDialog intentionally inflates the
 * iframe's intrinsic height beyond a normal viewport to show more of the
 * guest site. That inflation causes `100svh`-keyed elements (notably the
 * `photoBackground` header) to stretch far past their designed aspect ratio.
 * When this flag is set, the affected layouts opt into aspect-ratio-driven
 * auto height instead of viewport-based height.
 */
export const TEMPLATE_PREVIEW_MODAL_QUERY_PARAM = 'templatePreviewModal';

export const isInTemplatePreviewModal = (): boolean =>
  withWindow(win => {
    try {
      return new URLSearchParams(win.location.search).get(TEMPLATE_PREVIEW_MODAL_QUERY_PARAM) === 'true';
    } catch {
      return false;
    }
  }, false);
